import { Box, Grid, GridItem, Text } from "@chakra-ui/react";
import { MinimalOrgDto, type SupplierRelationDto } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { OrganizationTypeTag } from "../../../common/organization/OrganizationTypeTag";
import { SupplierRelationTags } from "../../../common/organization/supplier-filters/SupplierRelationTags";
import { SearchResultContent } from "./SearchResultContent";

interface Props {
  organization: MinimalOrgDto;
  relations: SupplierRelationDto[];
}

export const SearchResult = ({ organization, relations }: Props) => {
  const authState = useLoggedInWithOrgContextState();
  const isSelectedOrg = organization.id === authState.selectedOrg.id;

  return (
    <Grid
      gridTemplateColumns={{ base: "50px minmax(0, 1fr)", md: "50px minmax(0, 1fr) auto" }}
      columnGap="3"
      rowGap="2"
      marginLeft={4}
      w="100%"
    >
      <GridItem>
        <Box
          overflow="hidden"
          bg={isSelectedOrg ? "blue.500" : organization.type === "Organization" ? "blue.500" : "gray.400"}
          h="50px"
          borderRadius={"10px"}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          <Text fontWeight={"bold"} color="smBackground">
            {organization.name.charAt(0)}
          </Text>
        </Box>
      </GridItem>
      <GridItem>
        <SearchResultContent organization={organization} />
      </GridItem>
      <GridItem
        gridColumn={{ base: "2", md: "auto" }}
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        gap="2"
      >
        <SupplierRelationTags relations={relations} justify={{ base: "start", md: "end" }} />
        <Box mr="15px">
          <OrganizationTypeTag type={organization.type} isCurrentlyLoggedIn={isSelectedOrg} size="sm" />
        </Box>
      </GridItem>
    </Grid>
  );
};
